import React from "react";
import { Switch } from "react-router-dom";
import * as Loadable from 'react-loadable';
import Loading from './components/Loading';
import AppliedRoute from './components/AppliedRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';


const AsyncNotFound = Loadable({
  loader: () => import("./app/NotFound/index"),
  loading: Loading
})

const AsyncHome = Loadable({
  loader: () => import("./app/Home/index"),
  loading: Loading
})

const AsyncTongjiNew = Loadable({
  loader: () => import("./app/Tongji/tongjiNew"),
  loading: Loading
})

const  AsyncTongjiResult=Loadable({
  loader: () => import("./app/Tongji/tongjiResult"),
  loading: Loading
})

const AsyncExamRank = Loadable({
  loader: () => import("./app/Exam/rank"),
  loading: Loading
})

const AsyncBookResult = Loadable({
  loader: () => import("./app/Booking/bookResult"),
  loading: Loading
})

const AsyncToupiaoNew = Loadable({
  loader: () => import("./app/Toupiao/toupiaoNew"),
  loading: Loading
})
const AsyncLogin = Loadable({
  loader: () => import("./app/Login"),
  loading: Loading
});

const AsyncToupiaoResult = Loadable({
  loader: () => import("./app/Toupiao/toupiaoResult"),
  loading: Loading
})

const AsyncCreate = Loadable({
  loader: () => import("./app/Create/index"),
  loading: Loading
})


const AsyncManager = Loadable({
  loader: () => import("./app/Manager/index"),
  loading: Loading
})

const AsyncTemplate = Loadable({
  loader: () => import("./app/Template/index"),
  loading: Loading
})
const AsyncCreateTemplate = Loadable({
  loader: () => import("./app/Create/template"),
  loading: Loading
})
const AsyncMyTemplate = Loadable({
  loader: () => import("./app/Template/myTemplate"),
  loading: Loading
})

const AsyncEventVoteNew = Loadable({
  loader: () => import("./app/eventVote/eventNew"),
  loading: Loading
})
const AsyncChaChaNew = Loadable({
  loader: () => import("./app/Chacha/chachaNew"),
  loading: Loading
})
const AsyncBookNew = Loadable({
  loader: () => import("./app/Booking/bookNew"),
  loading: Loading
})

const AsyncExamNew=Loadable({
  loader: () => import("./app/Exam/index"),
  loading: Loading
})
const AsyncChat = Loadable({
  loader: () => import("./app/Chat/index"),
  loading: Loading
})

const AsyncChatDetail = Loadable({
  loader: () => import("./app/Chat/detail"),
  loading: Loading
})
const AsyncContent = Loadable({
  loader: () => import("./app/Content/index"),
  loading: Loading
})

const AsyncContentDetail = Loadable({
  loader: () => import("./app/Content/detail"),
  loading: Loading
})

const AsyncOrg = Loadable({
  loader: () => import("./app/Org/index"),
  loading: Loading
})
const AsyncOrgDetail = Loadable({
  loader: () => import("./app/Org/detail"),
  loading: Loading
})

const AsyncOrgInvite = Loadable({
  loader: () => import("./app/Org/inviteOrg"),
  loading: Loading

})

const AsyncOrgManage = Loadable({
  loader: () => import("./app/Org/orgManage"),
  loading: Loading
})

const AsyncTuangouNew = Loadable({
  loader: () => import("./app/Tuangou/tuangouNew"),
  loading: Loading
})

const AsyncMiddlePage = Loadable({
  loader: () => import("./app/Middle/index"),
  loading: Loading
})
const AsyncViewPage = Loadable({
  loader: () => import("./app/Middle/view"),
  loading: Loading
})

const AsyncTuangouResult = Loadable({
  loader: () => import("./app/Tuangou/result"),
  loading: Loading

})
const AsyncChachaResult = Loadable({
  loader: () => import("./app/Chacha/record"),
  loading: Loading

})
const AsyncContentCheck = Loadable({
  loader: () => import("./app/Content/contentCheck"),
  loading: Loading
})

// const AsyncManagers = Loadable({
//   loader: () => import("./app/Home/manager"),
//   loading: Loading
// })


const router= ({ childProps }) =>

  <Switch>
    <AuthenticatedRoute
      path="/"
      exact
      component={AsyncHome}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/manager"
      exact
      component={AsyncManager}
      props={childProps}
    />
    <AppliedRoute
      path="/login"
      exact
      component={AsyncLogin}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/create"
      exact
      component={AsyncCreate}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/createTemplate"
      exact
      component={AsyncCreateTemplate}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/templates"
      exact
      component={AsyncTemplate}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/myTemplates"
      exact
      component={AsyncMyTemplate}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/tongji/new/:id"
      exact
      component={AsyncTongjiNew}
      props={childProps}
    />

    <AuthenticatedRoute
      path="/tongji/result/:id"
      exact
      component={AsyncTongjiResult}
      props={childProps}
    />
     <AuthenticatedRoute
      path="/exam/rank/:id"
      exact
      component={AsyncExamRank}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/toupiao/new/:id"
      exact
      component={AsyncToupiaoNew}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/toupiao/result/:id"
      exact
      component={AsyncToupiaoResult}
      props={childProps}
    />

    <AuthenticatedRoute
      path="/eventVote/new/:id"
      exact
      component={AsyncEventVoteNew}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/chacha/new/:id"
      exact
      component={AsyncChaChaNew}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/book/new/:id"
      exact
      component={AsyncBookNew}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/exam/new/:id"
      exact
      component={AsyncExamNew}
      props={childProps}
    />


    <AuthenticatedRoute
      path="/book/result/:id"
      exact
      component={AsyncBookResult}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/chat"
      exact
      component={AsyncChat}
      props={childProps}
    />

    <AuthenticatedRoute
      path="/chat/:id"
      exact
      component={AsyncChatDetail}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/content"
      exact
      component={AsyncContent}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/content/:id"
      exact
      component={AsyncContentDetail}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/contentCheck"
      exact
      component={AsyncContentCheck}
      props={childProps}
    />


    <AuthenticatedRoute
      path="/org"
      exact
      component={AsyncOrg}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/org/:id/inviteOrg"
      exact
      component={AsyncOrgInvite}
      props={childProps}
    />

    <AuthenticatedRoute
      path="/org/:id"
      exact
      component={AsyncOrgDetail}
      props={childProps}
    />

    {/* <AuthenticatedRoute
      path="/manager/:id"
      exact
      component={AsyncManagers}
      props={childProps}
    /> */}
    <AuthenticatedRoute
      path="/orgManage"
      exact
      component={AsyncOrgManage}
      props={childProps}
    />

    <AuthenticatedRoute
      path="/tuangou/new/:id"
      exact
      component={AsyncTuangouNew}
      props={childProps}
    />

    <AuthenticatedRoute
      path="/middlePage"
      exact
      component={AsyncMiddlePage}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/viewPage"
      exact
      component={AsyncViewPage}
      props={childProps}
    />
<AuthenticatedRoute
      path="/chacha/record/:id"
      exact
      component={AsyncChachaResult}
      props={childProps}
    />


    <AuthenticatedRoute
      path="/tuangou/result/:id"
      exact
      component={AsyncTuangouResult}
      props={childProps}
    />
    {/* Finally, catch all unmatched routes */}
    <AppliedRoute component={AsyncNotFound} />
    
  </Switch>;



export default router;